import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgFor } from '@angular/common';
import { IconComponent } from './icon.component';

/** Five-star rating display. */
@Component({
  selector: 'app-stars',
  standalone: true,
  imports: [NgFor, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<span style="display:inline-flex;gap:1px">
      <app-icon *ngFor="let n of stars" name="solar:star-bold" [size]="size"
        [color]="n <= rounded ? 'var(--gold)' : 'var(--fr-border-2)'"></app-icon>
    </span>`,
})
export class StarsComponent {
  @Input() value = 5;
  @Input() size = 13;
  readonly stars = [1, 2, 3, 4, 5];
  get rounded(): number { return Math.round(this.value); }
}
